import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-premium';
import { isArray } from 'lodash';

import { Enum } from '~/data/enums';
import { getFormattedDateString } from '~/utils/helpers/date';
import { getEnumName } from '~/utils/helpers/enum';

// Column configs utils
export const conditionalGridColDefs = <
  T extends GridValidRowModel = GridValidRowModel,
>(
  condition: boolean,
  column: GridColDef<T> | GridColDef<T>[],
): GridColDef<T>[] => {
  if (condition) {
    return isArray(column) ? column : [column];
  }

  return [];
};

export const dateCellValueFormatter = (value: Date | undefined) =>
  getFormattedDateString(value, 'L');

// SingleSelect -type column using Enums
export const findDuplicateEnumByCode = (enum2: Enum) => (enum1: Enum) =>
  enum2.code === enum1.code;

export const getSingleSelectColumnEnumValueOptions = (
  enumOptions: Enum[],
  filterOptionCodes?: string[],
  filterDuplicateEnumsByCode?: boolean,
) => {
  const uniqueEnums = filterDuplicateEnumsByCode
    ? enumOptions.filter(
        (enum1, index, array) =>
          array.findIndex(findDuplicateEnumByCode(enum1)) === index,
      )
    : enumOptions;

  const availableEnums = !!filterOptionCodes
    ? uniqueEnums.filter(({ code }) => filterOptionCodes.includes(code))
    : uniqueEnums;

  return availableEnums.map((e) => e.name);
};

export const enumCellValueGetter =
  (enumList: Enum[]) =>
  (value: string | undefined): string => {
    const enumName = !!value ? getEnumName(enumList, value) : undefined;
    return enumName ?? value ?? '';
  };

// Column Groups utils
export const getFieldNamesFromColumnConfig = <T extends GridValidRowModel>(
  gridColDefs: GridColDef<T>[],
) => gridColDefs.map(({ field }) => ({ field: field }));
